import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SimpleResponse } from '../models/generic-response.model';
import { MembershipListRequest, MembershipResponse, MemCaseListRequest, MemCaseResponse, MemContact, MemInsuranceDeductible, MemInsuranceDeductibleListRequest, MemInsuranceDeductibleResponse, REFMem_GetAllResponse, MemPolicyViolationListRequest, MemPolicyViolationResponse, MemPolicyViolation, Membership, MemCase, MemPause, MemPauseListRequest, MemSubscriptionListRequest, MemPauseResponse, MemSubscriptionResponse, MemSubscription, MemContactListRequest, MemContactListDropDown, MemContactResponse } from '../models/membership.model';
import { REF_CMStatusResponse } from '../models/cm-contract';
import { delayedRetryHttp } from './shared/delayed-retry';
import { UtilityService } from './shared/utility.service';

@Injectable({
    providedIn: 'root'
})
export class MembershipService {

    private baseUrl: string;
    private api: string = 'api/Membership';


    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    async memPolicyViolation_GetList(encryptedUser: string, request: MemPolicyViolationListRequest, clpuserId: number): Promise<MemPolicyViolationResponse | void> {
        const a = await this.httpClient
            .post<MemPolicyViolationResponse>(`${this.baseUrl}/MemPolicyViolation_GetList/${clpuserId}`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpuserId - " + clpuserId, encryptedUser, "MembershipService", "MemPolicyViolation_GetList"); });
        return a;
    }

    async memPolicyViolation_Create(encryptedUser: string, request: MemPolicyViolation): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemPolicyViolation_Create`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPolicyViolation_Create"); });
        return a;
    }

    async memPolicyViolation_Update(encryptedUser: string, request: MemPolicyViolation): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemPolicyViolation_Update`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPolicyViolation_Update"); });
        return a;
    }

    async memPolicyViolation_Delete(encryptedUser: string, policyViolationId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemPolicyViolation_Delete/${policyViolationId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPolicyViolation_Delete"); });
        return a;
    }

    async memPolicyViolation_Get(encryptedUser: string, policyViolationId: number, contactID:number): Promise<MemPolicyViolation | void> {
        const a = await this.httpClient
            .get<MemPolicyViolation>(`${this.baseUrl}/MemPolicyViolation_Get?policyViolationId=${policyViolationId}&contactID=${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPolicyViolation_Get"); });
        return a;
    }

    async memInsuranceDeductible_Create(encryptedUser: string, request: MemInsuranceDeductible): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemInsuranceDeductible_Create`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, request, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemInsuranceDeductible_Create"); });
        return a;
    }

    async memInsuranceDeductible_Update(encryptedUser: string, request: MemInsuranceDeductible): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemInsuranceDeductible_Update`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, request, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemInsuranceDeductible_Update"); });
        return a;
    }

    async memInsuranceDeductible_Delete(encryptedUser: string, id: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemInsuranceDeductible_Delete/${id}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + " id " + id, encryptedUser, "MembershipService", "MemInsuranceDeductible_Delete"); });
        return a;
    }


    async memInsuranceDeductible_Get(encryptedUser: string, id: number, contactID: number): Promise<MemInsuranceDeductible | void> {
        const a = await this.httpClient
            .get<MemInsuranceDeductible>(`${this.baseUrl}/MemInsuranceDeductible_Get?id=${id}&contactID=${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + " id " + id, encryptedUser, "MembershipService", "MemInsuranceDeductible_Get"); });
        return a;
    }

    async memInsuranceDeductible_GetList(encryptedUser: string, request: MemInsuranceDeductibleListRequest, clpuserId: number): Promise<MemInsuranceDeductibleResponse | void> {
        const a = await this.httpClient
            .post<MemInsuranceDeductibleResponse>(`${this.baseUrl}/MemInsuranceDeductible_GetList/${clpuserId}`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, request, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemInsuranceDeductible_GetList"); });
        return a;
    }

    async membership_GetList(encryptedUser: string, request: MembershipListRequest, clpuserId: number): Promise<MembershipResponse | void> {
        const a = await this.httpClient
            .post<MembershipResponse>(`${this.baseUrl}/Membership_GetList/${clpuserId}`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpuserId - " + clpuserId, encryptedUser, "MembershipService", "membership_GetList"); });
        return a;
    }
    
    async membership_Update(encryptedUser: string, membership: Membership): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/Membership_Update`, membership, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + ",", encryptedUser, "MembershipService", "membership_Update"); });
        return a;
    }
    
    async Membership_Get(encryptedUser: string, incrementalID: number): Promise<Membership | void> {
        const a = await this.httpClient
            .get<Membership>(`${this.baseUrl}/Membership_Get/${incrementalID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + ",", encryptedUser, "MembershipService", "Membership_Get"); });
        return a;
    }

    async memCase_GetList(encryptedUser: string, request: MemCaseListRequest, clpuserId: number): Promise<MemCaseResponse | void> {
        const a = await this.httpClient
            .post<MemCaseResponse>(`${this.baseUrl}/MemCase_GetList/${clpuserId}`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpuserId - " + clpuserId, encryptedUser, "MembershipService", "memCase_GetList");  });
        return a;
    }
    
    async MemCase_GetByContactId(encryptedUser: string, contactId:number): Promise<MemCaseResponse | void> {
        const a = await this.httpClient
            .get<MemCaseResponse>(`${this.baseUrl}/MemCase_GetByContactId/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "contactId - " + contactId, encryptedUser, "MembershipService", "MemCase_GetByContactId");  });
        return a;
    }

    async REF_Membership_GetAll(encryptedUser: string, clpCompanyId: number): Promise<REFMem_GetAllResponse | void> {
        const a = await this.httpClient
            .get<REFMem_GetAllResponse>(`${this.baseUrl}/REF_Membership_GetAll/${clpCompanyId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "REF_Membership_GetAll"); });
        return a;
    }


    //#region memContact
    async memContact_Create(encryptedUser: string, request: MemContact): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemContact_Create`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPolicyViolation_GetList"); });
        return a;
    }
    async memContact_Update(encryptedUser: string, request: MemContact): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemContact_Update`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPolicyViolation_GetList"); });
        return a;
    }

    async memContact_Delete(encryptedUser: string, contactId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemContact_Delete/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "contactId - " + contactId, encryptedUser, "MembershipService", "MemContact_Delete"); });
        return a;
    }

    async memContact_Get(encryptedUser: string, contactId: number): Promise<MemContact | void> {
        const a = await this.httpClient
            .get<MemContact>(`${this.baseUrl}/MemContact_Get/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "contactId - " + contactId, encryptedUser, "MembershipService", "memContact_Get"); });
        return a;
    }

    async memContact_cmMember_GetList(encryptedUser: string, request: MemContactListRequest, clpuserId: number): Promise<MemContactResponse | void> {
        const a = await this.httpClient
            .post<MemContactResponse>(`${this.baseUrl}/MemContact_CMMember_GetList/${clpuserId}`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpuserId - " + clpuserId, encryptedUser, "MembershipService", "cmMember_Contact_GetList"); }); //toPromise();
        return a;
    }

    async memCase_Create(encryptedUser: string, memCase: MemCase): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemCase_Create`, memCase, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemCase_Create"); });
        return a;
    }

    async memCase_Update(encryptedUser: string, memCase: MemCase): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemCase_Update`, memCase, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemCase_Update"); });
        return a;
    }

    async memCase_Delete(encryptedUser: string, caseId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemCase_Delete/${caseId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemCase_Delete"); });
        return a;
    }

    async memCase_Get(encryptedUser: string, caseId: number): Promise<MemCase | void> {
        const a = await this.httpClient
            .get<MemCase>(`${this.baseUrl}/MemCase_Get/${caseId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemCase_Get"); });
        return a;
    }

    async memPause_Create(encryptedUser: string, memPause: MemPause): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemPause_Create`, memPause, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPause_Create"); });
        return a;
    }

    async memPause_Update(encryptedUser: string, memPause: MemPause): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemPause_Update`, memPause, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPause_Update"); });
        return a;
    }

    async memPause_Delete(encryptedUser: string, pauseId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemPause_Delete/${pauseId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPause_Delete"); });
        return a;
    }

    async memPause_Get(encryptedUser: string, pauseId: number,contactID:number): Promise<MemPause | void> {
        const a = await this.httpClient
            .get<MemPause>(`${this.baseUrl}/MemPause_Get?pauseId=${pauseId}&contactID=${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemPause_Get"); });
        return a;
    }

    async memPause_GetList(encryptedUser: string, request: MemPauseListRequest, clpuserId: number): Promise<MemPauseResponse | void> {
        const a = await this.httpClient
            .post<MemPauseResponse>(`${this.baseUrl}/MemPause_GetList/${clpuserId}`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpuserId - " + clpuserId, encryptedUser, "MembershipService", "MemPause_GetList"); });
        return a;
    }

    async memSubscription_GetList(encryptedUser: string, request: MemSubscriptionListRequest, clpuserId: number): Promise<MemSubscriptionResponse | void> {
        const a = await this.httpClient
            .post<MemSubscriptionResponse>(`${this.baseUrl}/MemSubscription_GetList/${clpuserId}`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "clpuserId - " + clpuserId, encryptedUser, "MembershipService", "MemSubscription_GetList"); });
        return a;
    }
    //#endregion memContact

    async memSubscription_Update(encryptedUser: string, request: MemSubscription): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemSubscription_Update`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, request, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemSubscription_Update"); });
        return a;
    }

    async memSubscription_Create(encryptedUser: string, request: MemSubscription): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/MemSubscription_Create`, request, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, request, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemSubscription_Create"); });
        return a;
    }


    async subscription_Delete(encryptedUser: string, subscriptionId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .post<SimpleResponse>(`${this.baseUrl}/Subscription_Delete/${subscriptionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe().toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "Subscription_Delete"); });
        return a;
    }

    async memSubscription_Get(encryptedUser: string, subscriptionId: number,contactID:number): Promise<MemSubscription | void> {
        const a = await this.httpClient
            .get<MemSubscription>(`${this.baseUrl}/MemSubscription_Get?subscriptionId=${subscriptionId}&contactID=${contactID}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "MemSubscription_Get"); });
        return a;
    }

    async memSubscription_GetByMemId(encryptedUser: string, membershipId: number): Promise<MemSubscription[] | void> {
        const a = await this.httpClient
            .get<MemSubscription[]>(`${this.baseUrl}/MemSubscription_GetByMemberShipId/${membershipId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "memSubscription_GetByMemId"); });
        return a;
    }

    async memContact_CMMember_GetList_DD(encryptedUser: string, clpCompanyId: number, clpuserId: number, clubId: number = 0): Promise<MemContactListDropDown[] | void> {
        const a = await this.httpClient
            .get<MemContactListDropDown[]>(`${this.baseUrl}/MemContact_CMMember_GetList_DD/${clpCompanyId}/${clpuserId}?clubId=${clubId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "memContact_CMMember_GetList_DD"); });
        return a;
    }

    async membership_GetByContactID(encryptedUser: string, contactId: number): Promise<Membership | void> {
        const a = await this.httpClient
            .get<Membership>(`${this.baseUrl}/Membership_GetByContactID/${contactId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser, encryptedUser, "MembershipService", "memContact_CMMember_GetList_DD"); });
        return a;
    }
}
